<!-- 生成库存盘点计划 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <div class="page_title">
                    <el-alert :title="dataActionBox.boxTitle" type="success" effect="dark" :closable="false">
                    </el-alert>
                </div>
                <el-tabs type="border-card" v-model="jciName" class="el-tabs--border-card_new">
                    <el-tab-pane :label="jciName" :name="jciName">
                        <div class="table_content_box">
                            <el-form label-width="150px" :show-message="false" class="baseForm" :model="sendDataInfo"
                                ref="sendDataInfo" size="mini">
                                <el-row>
                                    <el-form-item label="上限" prop="upperLimit">
                                        <label slot="label" :style="$common.labelStyle('上限')" v-html="'上限'"></label>
                                        <el-input  class="form_codition" type="number" v-model="sendDataInfo.upperLimit"
                                            :maxlength="$store.state.inputLength"></el-input>
                                    </el-form-item>
                                    <el-form-item label="下限" prop="lowerLimit">
                                        <label slot="label" :style="$common.labelStyle('下限')" v-html="'下限'"></label>
                                        <el-input class="form_codition" type="number" v-model="sendDataInfo.lowerLimit"
                                            :maxlength="$store.state.inputLength"></el-input>
                                    </el-form-item>
                                    <el-form-item label="类型" prop="type">
                                        <label slot="label" :style="$common.labelStyle('类型')" v-html="'类型'"></label>
                                        <el-select  class="form_codition" v-model="sendDataInfo.type" placeholder="请选择类型" @change="selChange">
                                            <el-option label="固定金额" :value="0"></el-option>
                                            <el-option label="扣率" :value="1"></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="固定额度" prop="deductionMoney">
                                        <label slot="label" :style="$common.labelStyle('固定额度')" v-html="'固定额度'"></label>
                                        <el-input  class="form_codition" type="input" v-model="sendDataInfo.deductionMoney" :disabled="isShowMoney"
                                            :maxlength="$store.state.inputLength"></el-input>
                                    </el-form-item>
                                    <el-form-item label="扣率" prop="deductionRate">
                                        <label slot="label" :style="$common.labelStyle('扣率')" v-html="'扣率'"></label>
                                        <el-input  class="form_codition" type="input" v-model="sendDataInfo.deductionRate" :disabled="!isShowMoney"
                                            :maxlength="$store.state.inputLength"></el-input>
                                    </el-form-item>
                                    <el-form-item label="备注" prop="remark">
                                        <label slot="label" :style="$common.labelStyle('备注')" v-html="'备注'"></label>
                                        <el-input  class="form_codition" type="textarea" v-model="sendDataInfo.remark"
                                            :maxlength="$store.state.inputLength"></el-input>
                                    </el-form-item>
                                </el-row>

                            </el-form>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="foot">
                    <div style="text-align: center;">
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
    name: "ownerdeductionruleAction",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            selectDataTable: false,
            sendDataInfo: {
                upperLimit: "",
                lowerLimit: "",
                deductionMoney: "",
                deductionRate: "",
                remark: "",
                type: 0
            },
            isShowMoney: false,

            jciName: "新增货主扣费标准",
            selectedDataIndex: 0,
            storageRoomList: [],
            selectedDetails: [],
            selectGoodsInfo: "",
            showTabs: "",
            formDataList: [],
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            exWidth: "",
            parentSearchData: {
                movmOutstid: "",
            },
            mxHeight: 0,
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'sendDataInfo.lowerLimit': {
            handler: function (newValue, old) {
                if (this.sendDataInfo.lowerLimit == '') return
                if (newValue > this.sendDataInfo.upperLimit) {
                    this.sendDataInfo.lowerLimit = ''
                    return this.$message({
                        message: "下限不能高于上限",
                        type: "error",
                    });

                }
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        selChange(e) {
            console.log(e)
            this.$nextTick(() => {
                if (e == 0) {
                    this.isShowMoney = false
                } else {
                    this.isShowMoney = true
                }
            })
            this.$forceUpdate()
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) {
                this.$parent.$parent.toDetail(orderId);
            } else {
                this.$parent.$parent.$parent.toDetail(orderId);
            }
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            console.log(val);
            this.DialogVisible = false;
            console.log(this.seType);
            if (val != "" || val != undefined) {
                if (this.seType == "stId") {
                    this.sendDataInfo.stName = val.stName;
                    this.sendDataInfo.stId = val.stId;
                    this.parentSearchData.movmOutstid = this.sendDataInfo.movmOutstid;
                } else if (this.seType == "coId") {
                    this.sendDataInfo.coName = val.coName;
                    this.sendDataInfo.coId = val.coId;
                } else if (this.seType == "bgmName") {
                    for (let fkey in this.sendDataInfo.movedetailAdds[this.seIndex]) {
                        for (let vkey in val) {
                            if (fkey == vkey) {
                                this.sendDataInfo.movedetailAdds[this.seIndex][fkey] =
                                    val[vkey];
                            }
                        }
                    }
                    this.sendDataInfo.movedetailAdds[this.seIndex].movdOutbgsid =
                        val.bgsId;
                }
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type) {
            console.log(type, "----7");
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            if (type == 'stId') {
                this.parentSearchData["stName"] = this.sendDataInfo["stName"];
            }
            if (type == 'coId') {
                this.parentSearchData["coName"] = this.sendDataInfo["coName"];
            }
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        // 获取所有可用库房列表
        // async getAllStorageRoom() {
        //   let responseData = await this.$http.getAllStorageRoom();
        //   if (responseData.status == 200) {
        //     this.storageRoomList = responseData.result;
        //   } else {
        //     this.$message({
        //       message: responseData.message,
        //       type: "error",
        //     });
        //   }
        // },

        initActionBox(sendDataInfo) {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit('drawerCancel', 0)
                    this.init();
                    this.$refs.sendDataInfo[0].resetFields();
                })
                .catch(() => { });
        },
        // init() {
        //   for (let key in this.sendDataInfo) {
        //     this.sendDataInfo[key] = "";
        //   }
        //   this.sendDataInfo.totalCount = 0; //总条目数
        //   this.sendDataInfo.totalMoney = 0; // 总金额
        //   this.sendDataInfo.totalNumber = 0; // 总数量
        // },
        // async isShowData(name, value) {
        //   this.sendDataInfo[name] = value;
        // },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            // this.showTabs = this.actionData.formData[0].jciName
            // this.filterMainField()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.jciName = "新增货主扣费标准"

            } else {
                this.dataActionBox.boxTitle = '修改信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                this.jciName = "修改货主扣费标准"
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
                if (oldData.type == 0) {
                    this.isShowMoney = false
                } else {
                    this.isShowMoney = true
                }
            }
            console.log(oldData.type)

            // this.$nextTick(() => {
            //   var sheight = this.$refs.sendDataInfo[0].$el.clientHeight;
            //   this.mxHeight = document.documentElement.clientHeight - sheight - 280;
            // });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
        },
        // 新增或者编辑
        sendDataAction(sendDataInfo) {
            console.log(sendDataInfo);
            // this.$refs.sendDataInfo[0].validate((valid) => {
            //   if (valid) {
            this.sub();
            //   } else {
            //     return false;
            //   }
            // });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addOwnerdeduc(sendData);
            } else {
                var responseData = await this.$http.upDateOwnerdeduc(sendData);
            }
            if (responseData.status == 200) {
                this.$emit('drawerCancel', 1)
                // this.init();
                this.$message.success("操作成功");
            } else {
                this.$message.error(responseData.message);
            }
        },
        deleteDetails(index) {
            if (this.sendDataInfo.movedetailAdds.length > 0) {
                this.sendDataInfo.movedetailAdds.splice(this.selectedDataIndex, 1);
                this.selectedDataIndex = 0;
            } else {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
        // this.getAllStorageRoom();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.foot {
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: absolute;
    bottom: -27px;
    left: 49%;
    transform: translate(-50%, -50%); */
    width: 100%;
    background: #fff;
    padding: 14px 0;
    z-index: 999;
}

.foot .el-form {
    margin-left: 20px;
}

.foot .el-form .el-form-item {
    margin-bottom: 0;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>